import React from 'react';
import styled, { keyframes } from 'styled-components';
import colors from 'theme/colors';
import fonts from 'theme/fonts';
import { panelAccent, panelAccentAlpha } from 'theme/panelAccent';

export default function AdditionalHubCard({ icon: Icon, title, description, badge, comingSoon, onClick }) {
    function handleKeyDown(e) {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            if (!comingSoon) onClick();
        }
    }

    return (
        <Card
            role="button"
            tabIndex={comingSoon ? -1 : 0}
            disabled={comingSoon}
            onClick={comingSoon ? undefined : onClick}
            onKeyDown={handleKeyDown}
            aria-disabled={comingSoon}
        >
            <IconContainer>
                <Icon size={22} color={panelAccent(colors.occasionalPurple)} />
            </IconContainer>

            <Title>{title}</Title>
            <Description>{description}</Description>
            <Badge comingSoon={comingSoon}>{badge}</Badge>
        </Card>
    );
}

const Card = styled.div`
    background: ${colors.neutralLight};
    border-radius: 12px;
    padding: 24px;
    box-shadow: 0 1px 8px ${colors.night}08;
    border: 1px solid ${colors.night}11;
    cursor: pointer;
    transition: transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease;
    outline: none;

    &:hover {
        transform: translateY(-2px);
        box-shadow: 0 4px 16px ${colors.night}14;
        border-color: ${panelAccentAlpha(colors.secondaryPurple, '33')};
    }

    &:focus-visible {
        border-color: ${panelAccent(colors.secondaryPurple)};
        box-shadow: 0 0 0 3px ${panelAccentAlpha(colors.secondaryPurple, '22')};
    }

    ${({ disabled }) => disabled && `
        opacity: 0.55;
        cursor: default;
        pointer-events: none;
    `}
`;

const IconContainer = styled.div`
    width: 40px;
    height: 40px;
    border-radius: 10px;
    background: ${panelAccentAlpha(colors.occasionalPurple, '12')};
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 14px;
`;

const Title = styled.span`
    display: block;
    font-size: ${fonts.sizes.highlight};
    font-weight: 600;
    color: ${colors.nightDark};
    margin-bottom: 6px;
`;

const Description = styled.span`
    display: block;
    font-size: ${fonts.sizes.small};
    color: ${colors.night};
    line-height: 1.4;
    margin-bottom: 14px;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
`;

const Badge = styled.span`
    display: inline-block;
    font-size: ${fonts.sizes.small};
    font-weight: 600;
    padding: 4px 12px;
    border-radius: 30px;
    background: ${({ comingSoon }) => comingSoon ? '#F3E8FF' : `${panelAccentAlpha(colors.secondaryPurple, '10')}`};
    color: ${panelAccent(colors.secondaryPurple)};
`;
